<template>
    <div>
        <template v-if="crud_poc === true">
            <div class="page-top mb-1 mb-3">
                <h1> Add POC</h1>
            </div>
            <div class="global-main">
                <form id="pocForm" @submit.prevent="addPOCData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Name </label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Email </label>
                            <input v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                            <has-error :form="form" field="email"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Phone </label>
                            <input v-model="form.phone" type="number" name="phone" class="form-control" :class="{ 'is-invalid': form.errors.has('phone') }">
                            <has-error :form="form" field="phone"></has-error>
                        </div>
                        <div class="form-group">
                            <label> City </label>
                            <select v-model="form.city_id" name="city_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('city_id') }" v-if="cities != null">
                                <option value="" selected>Select City</option>
                                <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                    {{ city.name }}
                                </option>
                            </select>
                            <has-error :form="form" field="city_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Source </label>
                            <select v-model="form.source" name="source" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('source') }">
                                <option value="" selected>Select Source</option>
                                <option value="FINJA">Finja Pvt LTD</option>
                                <option value="FINCA">Finca Microfinance Bank</option>
                            </select>
                            <has-error :form="form" field="source"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/pocs" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="crud_poc === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_poc === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                    email : '',
                    phone : '',
                    city_id : '',
                    source : ''
                }),
                crud_poc: null,
                cities: null,
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_poc').then(result => {
                this.crud_poc = result.crud_poc;
            }).then(result => {
                if(this.crud_poc == true){
                    this.getCityData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            addPOCData() {
                this.$Progress.start();
                this.form.post('api/addPoc')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','POC created successfully');
                        this.$router.push('/pocs');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getCityData(){
                axios.get('/api/cityData')
                .then(res => {
                    this.cities = res.data.record;
                }).then(res =>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.showAlertBox('error','Some error in your form data');
                });
            }
        }
    }
</script>
